export default {
    SIGSEGV: 'SIGSEGV - Segmentation fault of the program. This may be caused e.g. by an out-of-scope array ' +
     'index causing a buffer overflow, an incorrectly initialized pointer, etc.',
    SIGXFSZ: 'SIGXFSZ - Output limit exceeded. Your program has printed too much data to output (typically more than 25MB).',
    SIGFPE: 'SIGFPE - Floating point error - an error of the arithmetic co-processor, such as division by zero, etc.',
    SIGABRT: 'SIGABRT - Error raised by the program itself, e.g. by making the abort() system call. Note that STL in C++ can raise this ' +
     'signal under some conditions, e.g. due to insufficient memory.',
    OTHER: 'ERROR - Unknown runtime error',
};
